<form
  class="concepts-query"
  (submit)="submit()"
>
  <div class="concepts-query__input-container">
    @if (!hideIcon) {
      <div class="concepts-query__input-search-icon">
        <span class="search-icon">
          <i class="icon-search"></i>
        </span>
      </div>
    }

    <input
      type="text"
      id="searchQuery"
      autocomplete="off"
      [ngClass]="{'hasSearchIcon': !hideIcon}"
      [(ngModel)]="conceptsContainer.conceptsParams.query"
      [ngModelOptions]="{standalone: true}"
      placeholder="{{'TRANS__ADMIN_CONCEPT__QUERY_PLACEHOLDER' | translate}}"
    >

    @if (conceptsContainer.conceptsParams.query) {
      <a
        (click)="clearSearch()"
        class="concepts-query__clear-input"
      >
        <mat-icon>
          close
        </mat-icon>
      </a>
    }

    <a
      class="concepts-query__search-button text-primary"
      (click)="submit()"
    >
      <span class="uppercase">
        {{ 'TRANS__FILTER__SEARCH_PLACEHOLDER' | translate }}
      </span>
    </a>
  </div>

  <div>
    {{ queryMessage | translate }}
  </div>
</form>
